<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
      {{ reviewer.fullName }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
      {{ requester.fullName }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 tabular-nums text-right">
      {{ dateCreated }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
      <div class="flex space-x-2">
        <ApprovalClaimRequestApprovalAction
          :approval-claim-id="approvalClaim.id"
          :project-asset-id="approvalClaim.modelId"
          @approval-request-created="$emit('approval-request-created')"
        />
        <ApprovalClaimDeleteAction
          :approval-claim-id="approvalClaim.id"
          :project-asset-id="approvalClaim.modelId"
          @approval-claim-deleted="$emit('approval-claim-deleted')"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import moment from 'moment';
import ApprovalClaimDeleteAction from './ApprovalClaimDeleteAction.vue';
import ApprovalClaimRequestApprovalAction from './ApprovalClaimRequestApprovalAction.vue';

export default {
  components: {
    ApprovalClaimDeleteAction,
    ApprovalClaimRequestApprovalAction,
  },
  props: {
    approvalClaim: {
      type: Object,
      required: true,
    },
  },
  computed: {
    reviewer() {
      return this.approvalClaim.reviewer || { fullName: 'Missing reviewer' };
    },
    requester() {
      return this.approvalClaim.requester || { fullName: 'Missing requester' };
    },
    dateCreated() {
      return moment(this.approvalClaim.createdAt).format('ddd D MMM Y');
    },
  },
};
</script>
